import React, {Component} from "react";
import {route, routes} from "../../vars/rd";
import {$shutils} from "../../libs/snnh/snnh";

class Splash extends Component {
    timerId = null;
    mounted = false;
    componentDidMount() {
        this.mounted = true;
        this.startProgress();
    }

    componentWillUnmount() {
        if (this.timerId) clearTimeout(this.timerId);
        this.timerId = null;
        this.mounted = false;
    }

    startProgress() {
        let progress = 0;
        const progressBar = document.getElementById("progress-bar");
        const progressText = document.getElementById("progress-text");

        const updateProgress = () => {
            if (progress < 100) {
                progress = Math.min(100, progress + $shutils.random(1, 5));
                if (progressBar) {
                    progressBar.style.width = progress + "%";
                }
                if (progressText) {
                    if (progressText.innerText !== undefined) {
                        progressText.innerText = progress + "%";
                    } else {
                        progressText.textContent = progress + "%";
                    }
                }
                this.timerId = setTimeout(updateProgress, 100);
            } else {
                this.timerId = setTimeout(() => route(routes.login), 300);
            }
        };

        updateProgress();
    };

    render() {
        return (
            <div className="splash-screen">
                <video className="splash-img" muted autoPlay>
                    <source src="/images/splash.mp4" type="video/mp4"/>
                </video>
                <p id="progress-text">0%</p>
                <div className="progress-container">
                    <div className="progress-bar" id="progress-bar"></div>
                </div>
            </div>
        );
    }
}

export default Splash;


// WEBPACK FOOTER //
// ./src/pages/splash/index.jsx